import { matchSorter } from "match-sorter";

export function fuzzySearchMutipleWords(
  rows: any[], // array of data [{a: "a", b: "b"}, {a: "c", b: "d"}]
  keys: any[], // keys to search ["a", "b"]
  filterValue: string // potentially multi-word search string "two words"
) {
  if (!filterValue || !filterValue.length) {
    return rows;
  }

  const terms = filterValue.split(" ");
  if (!terms) {
    return rows;
  }

  // reduceRight will mean sorting is done by score for the _first_ entered word.
  return terms.reduceRight(
    (results, term) =>
      matchSorter(results, term, {
        keys,
        threshold: matchSorter.rankings.CONTAINS,
      }),
    rows
  );
}

export function pagination(
  length: number,
  currentPage: number,
  itemsPerPage: number
) {
  return {
    total: length,
    per_page: itemsPerPage,
    current_page: currentPage,
    last_page: Math.ceil(length / itemsPerPage),
    from: (currentPage - 1) * itemsPerPage + 1,
    to: currentPage * itemsPerPage,
  };
}
